// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"a303e444","453":"7b092f3a"}[chunkId] + ".chunk.js";
};